/* eslint-disable camelcase */
export const isLogin = () => {
  const token = localStorage.getItem("token");
  const is_authenticated = localStorage.getItem("is_authenticated");

  if (!token || !is_authenticated || is_authenticated === "0") {
    return false;
  }
  return true;
};

export const formatDateNoTimezone = (dateStr) => {
  var date = new Date(dateStr);
  var userTimezoneOffset = date.getTimezoneOffset() * 60000;
  date = new Date(date.getTime() + userTimezoneOffset);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract the month, day, and year from the Date object
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Format the date as 'Jul 10, 2024'
  const formattedDate = `${month} ${String(day).padStart(2, "0")}, ${year}`;
  return formattedDate;
};

export const formatDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return "";

  const [year, month, day] = dateStr.split("-").map(Number);

  if (!year || !month || !day) return "";

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Ensure valid month range
  if (month < 1 || month > 12) return "";

  return `${monthNames[month - 1]} ${String(day).padStart(2, "0")}, ${year}`;
};

export const dateSendToBackend = (dateStr) => {
  // const [month, day, year] = dateStr?.split("/");

  // const formattedDate = `${year}/${month}/${day}`;
  const date = new Date(dateStr);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
  const day = String(date.getDate()).padStart(2, "0");

  const formattedDate = `${year}/${month}/${day}`;

  return formattedDate;
};

export const getDatefromBackend = (dateStr) => {
  // const [year, month, day] = dateStr?.split("-");

  // const formattedDate = `${month}/${day}/${year}`;
  const date = new Date(dateStr);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract the month, day, and year from the Date object
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Format the date as 'Jul 10, 2024'
  const formattedDate = `${month} ${String(day).padStart(2, "0")}, ${year}`;

  return formattedDate;
};

// export const formatDateToYYYYMMDD = (date) => {
//   const year = date?.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() is zero-based
//   const day = String(date.getDate()).padStart(2, "0");

//   const formattedDate = `${year}/${month}/${day}`;
//   return formattedDate;
// };

export const formatDateToMMDDYYYY = (date) => {
  // const year = date?.getFullYear();
  // const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() is zero-based
  // const day = String(date.getDate()).padStart(2, "0");

  // const formattedDate = `${month}/${day}/${year}`;
  const getDate = new Date(date);

  // Define an array of month names for formatting purposes
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract the month, day, and year from the Date object
  const month = monthNames[getDate.getMonth()];
  const day = getDate.getDate();
  const year = getDate.getFullYear();

  // Format the date as 'Jul 01, 2024'
  const formattedDate = `${month} ${String(day).padStart(2, "0")}, ${year}`;
  return formattedDate;
};

export function formatDateToMMYYYY(date) {
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${year}`;
}

export const imageBaseUrl = process?.env?.REACT_APP_IMAGE_BASE_URL;

export const randomString = (length) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const randomSecurityCode = (length = 4) => {
  let result = "";
  const characters = "0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const convertToSlug = (str) =>
  str
    ?.toLowerCase()
    ?.replace(/ /g, "-")
    ?.replace(/[^\w-]+/g, "");

// export const selectedPaymentType = (array, id) => {
//   let payment_type;
//   for (const a of array) {
//     if (Number(a?.id) === Number(id)) {
//       payment_type = a?.payment_type;
//     }
//   }
//   return payment_type;
// };

export const minimizeName = (name,length) => {
  let lengthShouldbe = length||11;
  let lengthOfName = name?.length;
  if (lengthOfName > lengthShouldbe) {
    let returnName = name?.split("")?.slice(0, lengthShouldbe)?.join("");
    return `${returnName}...`;
  } else {
    return name;
  }
};

export function decodeHTMLEntities(text) {
  const entities = [
    ["amp", "&"],
    ["apos", "'"],
    ["#x27", "'"],
    ["#x2F", "/"],
    ["#39", "'"],
    ["#47", "/"],
    ["lt", "<"],
    ["gt", ">"],
    ["nbsp", " "],
    ["quot", '"'],
  ];
  let newText;
  if (text?.length > 0) {
    for (let i = 0, max = entities?.length; i < max; ++i)
      newText = text.replace(
        new RegExp(`&${entities[i][0]};`, "g"),
        entities[i][1]
      );

    return newText;
  }
  return "";
}

export const plainString = (text) => {
  let plainString = text?.replace(/<[^>]+>/g, "");
  return plainString;
};

export function isImageOrVideo(url) {
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
  const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi"];

  // Extract file extension
  const extension = url.split(".").pop().toLowerCase();

  if (imageExtensions.includes(extension)) {
    return "image";
  } else if (videoExtensions.includes(extension)) {
    return "video";
  } else {
    return "unknown";
  }
}

export const formateMobileNumber = (value) => {
  if (!value) return value;

  const phoneNumber = value.replace(/[^\d]/g, ""); // Remove all non-digit characters

  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) {
    return phoneNumber;
  }
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
};

export const validateNum = (num) => {
  let normalNum = num.replace(/[()\-]/g, "");
  const regex = /^[0-9]{10}$/;
  return regex.test(normalNum);
};

export const navigateToAzTimes=()=>{
  window.location.href = "http://azindiatimes.com/epaper/";
}


// export const accData = {
//   id: 50,
//   role_id: 0,
//   full_name: "Tannerr Barry",
//   first_name: "Tannerr",
//   last_name: "Barry",
//   user_name: null,
//   city_id: 62,
//   state_id: 20,
//   zip_code: "44056",
//   address: "Dolor sint qui aperi",
//   email: "ansh.eww@gmail.com",
//   phone_number: "9938383889",
//   fax: null,
//   email_verified_at: null,
//   password_reset_token: null,
//   profile_image: "1732142153.webp",
//   is_associate: 0,
//   company_name: "Solis Kramer Inc",
//   gender: null,
//   dob: "2003-02-23",
//   status: 1,
//   isEmailSpeacialOffer: 0,
//   created_at: "2024-09-14T01:15:11.000000Z",
//   updated_at: "2025-02-21T17:59:00.000000Z",
//   created_by: null,
//   updated_by: null,
//   ip_address: "122.171.138.189",
//   deleted_at: null,
//   classified: [
//     {
//       id: 126,
//       cate_id: 1,
//       sub_cate_id: 0,
//       name: "Maile Gilbert",
//       description:
//         "Sit sit dolor laborum nulla rerum placeat et quibusdam exercitationem consequatur architecto deserunt reiciendis expedita nesciunt laboriosam duis enim",
//       type: "Premium",
//       start_date: "2025-03-14",
//       meta_description: "",
//       meta_keywords: "",
//       contact_detail: "Laborum et omnis qui",
//       contact_person_name: "Alika Schwartz",
//       email: "loka@mailinator.com",
//       phone_number: "(158)648-3881",
//       mobile: null,
//       url: null,
//       image: null,
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       created_at: "2025-02-28T18:39:52.000000Z",
//       updated_at: "2025-02-28T18:39:52.000000Z",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       is_expire: false,
//       images: [],
//       payment: {
//         id: 85,
//         user_id: 50,
//         classfied_id: 126,
//         type: "Premium",
//         checkout_id:
//           "cs_live_a1iDSbMLO4pTCosz0z7dKFjCF33DBAyuPd5LqJf3BpW20u8WoBNBpBmzyf",
//         amount: "5",
//         payment_status: 0,
//         purchase_date: "2025-02-28 11:39:52",
//         expire_date: "2025-03-30 11:39:52",
//         is_current_plan: 0,
//         created_at: "2025-02-28T18:39:52.000000Z",
//         updated_at: "2025-02-28T18:39:52.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//     {
//       id: 121,
//       cate_id: 6,
//       sub_cate_id: null,
//       name: "Burton Bullock",
//       description:
//         "<p>Sunt delectus aut non fugiat vitae<br><br><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ips</p>",
//       type: "Premium",
//       start_date: "2025-02-21",
//       meta_description: "",
//       meta_keywords: "",
//       contact_detail: "Molestiae deleniti s",
//       contact_person_name: "Lillith Richardson",
//       email: "jina@mailinator.com",
//       phone_number: "(143) 542-7844",
//       mobile: null,
//       url: null,
//       image: null,
//       created_by: 50,
//       updated_by: 1,
//       status: 1,
//       created_at: "2025-02-21T17:02:53.000000Z",
//       updated_at: "2025-02-28T21:58:13.000000Z",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       is_expire: false,
//       images: [],
//       payment: {
//         id: 80,
//         user_id: 50,
//         classfied_id: 121,
//         type: "Premium",
//         checkout_id: null,
//         amount: "5",
//         payment_status: 1,
//         purchase_date: "2025-02-21 10:02:53",
//         expire_date: "2025-03-23 10:02:53",
//         is_current_plan: 0,
//         created_at: "2025-02-21T17:02:53.000000Z",
//         updated_at: "2025-02-21T17:03:27.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//     {
//       id: 120,
//       cate_id: 8,
//       sub_cate_id: null,
//       name: "Hu Marks",
//       description:
//         "<p>Harum commodi ratione anim voluptatem ea unde est enim omnis deleniti consequatur Iste id quisquam eius pariatur Est assumenda a</p>",
//       type: "Premium",
//       start_date: "2025-02-21",
//       meta_description: "",
//       meta_keywords: "",
//       contact_detail: "Odit cupidatat nobis",
//       contact_person_name: "Petra Franklin",
//       email: "vudynosaz@mailinator.com",
//       phone_number: "(146) 518-3894",
//       mobile: null,
//       url: null,
//       image: null,
//       created_by: 50,
//       updated_by: 1,
//       status: 1,
//       created_at: "2025-02-21T17:02:15.000000Z",
//       updated_at: "2025-02-21T17:43:31.000000Z",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       is_expire: false,
//       images: [],
//       payment: {
//         id: 79,
//         user_id: 50,
//         classfied_id: 120,
//         type: "Premium",
//         checkout_id:
//           "cs_test_a1PlPyW9n9vzHQZbSV4Ey9chX6qSDHgBeCxw0Lx1p7oeGzggftY4blpCWz",
//         amount: "5",
//         payment_status: 1,
//         purchase_date: "2025-02-21 10:02:15",
//         expire_date: "2025-03-23 10:02:15",
//         is_current_plan: 0,
//         created_at: "2025-02-21T17:02:15.000000Z",
//         updated_at: "2025-02-21T17:43:31.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//     {
//       id: 82,
//       cate_id: 6,
//       sub_cate_id: null,
//       name: "Cedric Mayo",
//       description:
//         "<p>Hello. Looking for help with cooking/ chopping (for a family of 4) and folding/ ironing laundry twice per week, 4-5 hrs each visit. starting at $20/hr. Desert Ridge area. Need to drive yourself. Thank you.</p>",
//       type: "Premium",
//       start_date: "2025-01-13",
//       meta_description: "",
//       meta_keywords: "",
//       contact_detail: "Sireesha Veeranki",
//       contact_person_name: "Sireesha Veeranki",
//       email: "chinni04@yahoo.com",
//       phone_number: "(602) 432-2957",
//       mobile: null,
//       url: null,
//       image: "1736763434.jpg",
//       created_by: 50,
//       updated_by: 15,
//       status: 1,
//       created_at: "2024-11-12T17:37:08.000000Z",
//       updated_at: "2025-01-13T10:17:17.000000Z",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       is_expire: true,
//       images: [],
//       payment: {
//         id: 65,
//         user_id: 50,
//         classfied_id: 82,
//         type: "Premium",
//         checkout_id: null,
//         amount: "5",
//         payment_status: 1,
//         purchase_date: null,
//         expire_date: null,
//         is_current_plan: 0,
//         created_at: "2025-01-13T10:14:14.000000Z",
//         updated_at: "2025-01-13T10:14:14.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//     {
//       id: 81,
//       cate_id: 11,
//       sub_cate_id: null,
//       name: "Germaine Foster",
//       description:
//         "<p>No Lease Required - Private room Available in 4Bed 4bath Single family house. Address 107Ave and Happy Valley Prkwy Peoria 85383</p>",
//       type: "Premium",
//       start_date: "2024-11-13",
//       meta_description: "",
//       meta_keywords: "",
//       contact_detail: "Laxman Vemula",
//       contact_person_name: "Laxman Vemula",
//       email: "laxman.vemula@gmail.com",
//       phone_number: "(425) 614-6628",
//       mobile: null,
//       url: null,
//       image: null,
//       created_by: 50,
//       updated_by: 15,
//       status: 1,
//       created_at: "2024-11-12T17:31:01.000000Z",
//       updated_at: "2025-01-13T10:32:59.000000Z",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       is_expire: true,
//       images: [],
//       payment: {
//         id: 66,
//         user_id: 50,
//         classfied_id: 81,
//         type: "Premium",
//         checkout_id: null,
//         amount: "5",
//         payment_status: 1,
//         purchase_date: null,
//         expire_date: null,
//         is_current_plan: 0,
//         created_at: "2025-01-13T10:32:59.000000Z",
//         updated_at: "2025-01-13T10:32:59.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//     {
//       id: 80,
//       cate_id: 7,
//       sub_cate_id: 12,
//       name: "Uma Guerrero",
//       description:
//         "<p>Bharathanatyam dance classes in the traditional Tanjore style in chandler for kids and adults. Following the legacy and heritage of the great Bharathanatyam legend Smt.T. Balasarawati. Major crossroads for classes: Alma school and Germann rd</p>",
//       type: "Premium",
//       start_date: "2025-01-13",
//       meta_description: "",
//       meta_keywords: "",
//       contact_detail: "Charitra Sankar",
//       contact_person_name: "Charitra Sankar",
//       email: "charithra610@gmail.com",
//       phone_number: "(480) 394-1116",
//       mobile: null,
//       url: null,
//       image: null,
//       created_by: 50,
//       updated_by: 15,
//       status: 1,
//       created_at: "2024-11-12T17:24:23.000000Z",
//       updated_at: "2025-01-13T10:41:17.000000Z",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       is_expire: true,
//       images: [],
//       payment: {
//         id: 67,
//         user_id: 50,
//         classfied_id: 80,
//         type: "Premium",
//         checkout_id: null,
//         amount: "5",
//         payment_status: 1,
//         purchase_date: null,
//         expire_date: null,
//         is_current_plan: 0,
//         created_at: "2025-01-13T10:41:17.000000Z",
//         updated_at: "2025-01-13T10:41:17.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//     {
//       id: 79,
//       cate_id: 13,
//       sub_cate_id: null,
//       name: "Zena Melton",
//       description:
//         "<p>Asking Price- $5499 2007 Toyota Camry LE Sedan 4D Clean title, No Accidents Car Paid off Driven 129000 Newly Installed Backup camera Newly Installed Infotainment system with Bluetooth New Tires, New Alloy wheels New Brakes New Battery https://phoenix.craigslist.org/evl/cto/d/tempe-2007-toyota-camry-le-sedan-4d/7817711215.html</p>",
//       type: "Premium",
//       start_date: "2025-01-13",
//       meta_description: "",
//       meta_keywords: "",
//       contact_detail: "GR",
//       contact_person_name: "GR",
//       email: "gonev1rone@gmail.com",
//       phone_number: "(480) 381-7277",
//       mobile: null,
//       url: null,
//       image: "1736765381.jpg",
//       created_by: 50,
//       updated_by: 15,
//       status: 1,
//       created_at: "2024-11-12T17:20:14.000000Z",
//       updated_at: "2025-01-13T10:49:41.000000Z",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       is_expire: true,
//       images: [],
//       payment: {
//         id: 68,
//         user_id: 50,
//         classfied_id: 79,
//         type: "Premium",
//         checkout_id: null,
//         amount: "5",
//         payment_status: 1,
//         purchase_date: null,
//         expire_date: null,
//         is_current_plan: 0,
//         created_at: "2025-01-13T10:46:21.000000Z",
//         updated_at: "2025-01-13T10:46:21.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//     {
//       id: 78,
//       cate_id: 10,
//       sub_cate_id: 17,
//       name: "Tannerr Barry",
//       description:
//         "<p>11 years of experience in health insurance industry.<br>If you have friends and family visiting US and are in the market looking for Visitors Coverage, please contact me</p>",
//       type: "Premium",
//       start_date: "2024-11-13",
//       meta_description: "",
//       meta_keywords: "",
//       contact_detail: "SATISH GAJJALA",
//       contact_person_name: "SATISH GAJJALA",
//       email: "sgajjala01@gmail.com",
//       phone_number: "(317) 679-3669",
//       mobile: null,
//       url: null,
//       image: "1736765366.jpg",
//       created_by: 50,
//       updated_by: 15,
//       status: 1,
//       created_at: "2024-11-12T16:37:29.000000Z",
//       updated_at: "2025-01-13T10:49:26.000000Z",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       is_expire: true,
//       images: [],
//       payment: {
//         id: 69,
//         user_id: 50,
//         classfied_id: 78,
//         type: "Premium",
//         checkout_id: null,
//         amount: "5",
//         payment_status: 1,
//         purchase_date: null,
//         expire_date: null,
//         is_current_plan: 0,
//         created_at: "2025-01-13T10:49:26.000000Z",
//         updated_at: "2025-01-13T10:49:26.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//     {
//       id: 77,
//       cate_id: 20,
//       sub_cate_id: 0,
//       name: "Tannerr Barry",
//       description:
//         "Ut nihil animi earum aute nihil obcaecati mollit obcaecati laborum",
//       type: "Premium",
//       start_date: "2024-11-13",
//       meta_description: "",
//       meta_keywords: "",
//       contact_detail: "Dolor sint qui aperi",
//       contact_person_name: "Kalia Ewing",
//       email: "ansh.eww@gmail.com",
//       phone_number: "9938383889",
//       mobile: null,
//       url: null,
//       image: null,
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       created_at: "2024-11-12T16:37:04.000000Z",
//       updated_at: "2024-11-12T16:37:04.000000Z",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       images: [],
//       payment: null,
//     },
//   ],
//   business: [
//     {
//       id: 1110,
//       name: "Akanksha kumari",
//       cate_id: 56,
//       member: "non_member",
//       type: "Premium",
//       start_date: null,
//       description: "Test",
//       url: "https://test",
//       state_id: 1,
//       city_id: 193,
//       zip_code: 11111,
//       address:
//         "6429, NITTE Meenakshi College Rd, BSF Campus, Yelahanka, Bengaluru, Govindapura, Karnataka 560064",
//       image: null,
//       phone_number: "0748822440",
//       created_by: 50,
//       updated_by: 50,
//       created_at: "2025-02-11T17:06:20.000000Z",
//       updated_at: "2025-02-11T17:06:20.000000Z",
//       deleted_at: null,
//       status: 1,
//       ip_address: "1.23.215.85",
//       is_expire: true,
//       payment: {
//         id: 40,
//         user_id: 50,
//         business_id: 1110,
//         type: "Premium",
//         checkout_id:
//           "cs_test_a1Lt59ZOpTUrtQD70SvoxZ7JP1DFbPMwMmKR2O6EgIpJmWoiuYr5lXzgfQ",
//         amount: "25",
//         payment_status: 0,
//         purchase_date: "2025-02-11 10:06:20",
//         expire_date: "2025-03-13 10:06:20",
//         is_current_plan: 0,
//         created_at: "2025-02-11T17:06:20.000000Z",
//         updated_at: "2025-02-11T17:06:20.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//     {
//       id: 1107,
//       name: "test",
//       cate_id: 17,
//       member: "non_member",
//       type: "Standard",
//       start_date: null,
//       description: "test",
//       url: "https://www/test.com",
//       state_id: 1,
//       city_id: 685,
//       zip_code: 13434,
//       address: "test",
//       image: null,
//       phone_number: "1214365768",
//       created_by: 50,
//       updated_by: 50,
//       created_at: "2025-01-10T16:24:34.000000Z",
//       updated_at: "2025-01-10T16:24:34.000000Z",
//       deleted_at: null,
//       status: 1,
//       ip_address: "1.22.220.170",
//       is_expire: true,
//       payment: {
//         id: 37,
//         user_id: 50,
//         business_id: 1107,
//         type: "Standard",
//         checkout_id: null,
//         amount: null,
//         payment_status: 0,
//         purchase_date: "2025-01-10 09:24:34",
//         expire_date: "2025-02-09 09:24:34",
//         is_current_plan: 0,
//         created_at: "2025-01-10T16:24:34.000000Z",
//         updated_at: "2025-01-10T16:24:34.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//     {
//       id: 1098,
//       name: "Brittany Donovan",
//       cate_id: 22,
//       member: "non_member",
//       type: "Premium",
//       start_date: null,
//       description:
//         "Architecto voluptate veritatis dolorum officia error in velit voluptatem est ratione quam nulla eiusmod non",
//       url: "https://azindia.n2nhostings.com/",
//       state_id: 21,
//       city_id: 22,
//       zip_code: 23295,
//       address:
//         "Nostrum deserunt voluptatem consectetur et nobis adipisicing ea nostrum consequuntur dolores et dignissimos assumenda dolore quis doloremque elit odit",
//       image: "1729106020-image.jpg",
//       phone_number: "1763827758",
//       created_by: 50,
//       updated_by: 50,
//       created_at: "2024-10-17T02:13:40.000000Z",
//       updated_at: "2024-10-17T02:13:40.000000Z",
//       deleted_at: null,
//       status: 1,
//       ip_address: "103.112.218.174",
//       is_expire: true,
//       payment: {
//         id: 28,
//         user_id: 50,
//         business_id: 1098,
//         type: "Premium",
//         checkout_id:
//           "cs_test_a1Mz79OuHNj5kb5WTatTy4F5kumiyVNidSM9K7g0zfyMujtPg1Ku4KkIjo",
//         amount: "25",
//         payment_status: 1,
//         purchase_date: "2024-10-16 19:13:41",
//         expire_date: "2024-11-15 19:13:40",
//         is_current_plan: 1,
//         created_at: "2024-10-17T02:13:41.000000Z",
//         updated_at: "2024-10-17T02:14:07.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//     {
//       id: 1090,
//       name: "Regina Singleton",
//       cate_id: 40,
//       member: "member",
//       type: "Premium",
//       start_date: null,
//       description:
//         "Ipsa est elit impedit fugiat rem assumenda sunt officia autem ad blanditiis quidem et do laboriosam",
//       url: "https://google.com",
//       state_id: 20,
//       city_id: 408,
//       zip_code: 93939,
//       address: "Sit quo sit qui qui necessitatibus impedit exercitation ut",
//       image: "1728940796-image.jpg",
//       phone_number: "4494994940",
//       created_by: 50,
//       updated_by: 50,
//       created_at: "2024-10-15T04:19:56.000000Z",
//       updated_at: "2024-10-16T22:35:19.000000Z",
//       deleted_at: null,
//       status: 1,
//       ip_address: "103.112.218.174",
//       is_expire: true,
//       payment: {
//         id: 20,
//         user_id: 50,
//         business_id: 1090,
//         type: "Premium",
//         checkout_id:
//           "cs_test_a1gncwLMfg0HsBj5PwocvzdWn0EEtL2QA7OyhqilXUKBsXA6VqPP5Cx9wW",
//         amount: "25",
//         payment_status: 1,
//         purchase_date: "2024-10-14 21:19:56",
//         expire_date: "2024-11-13 21:19:56",
//         is_current_plan: 1,
//         created_at: "2024-10-15T04:19:56.000000Z",
//         updated_at: "2024-10-17T02:14:07.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//   ],
//   job: [],
//   megaphone: [
//     {
//       id: 67,
//       title: "Vero dignissimos min",
//       display_no: 1,
//       start_date: "2025-03-06",
//       end_date: null,
//       content:
//         "Nesciunt accusamus sunt repudiandae vero vero cum officiis quam odio voluptas",
//       image: "1741280867-image.jpg",
//       status: 1,
//       created_at: "2025-03-06T17:07:47.000000Z",
//       updated_at: "2025-03-06T17:07:47.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       is_expire: false,
//       payment: {
//         id: 33,
//         phone_id: 67,
//         user_id: 50,
//         type: "Premium",
//         checkout_id:
//           "cs_test_a1kr0vqe1lrGKZMQzD4pkLEpHgHSAX95LF24K1k6VufbCn2dkGEAp6sEcf",
//         amount: "5",
//         payment_status: 1,
//         purchase_date: "2025-03-06 10:07:48",
//         expire_date: "2025-03-21 00:00:00",
//         is_current_plan: 1,
//         created_at: "2025-03-06T17:07:48.000000Z",
//         updated_at: "2025-03-06T17:08:14.000000Z",
//         deleted_at: null,
//         email_sent: 0,
//         email_sent_one: 0,
//       },
//     },
//     {
//       id: 43,
//       title: "Fuga Necessitatibus",
//       display_no: 1,
//       start_date: "2024-11-13",
//       end_date: null,
//       content:
//         "Aliquid necessitatibus qui magnam modi voluptate voluptas eu blanditiis,Aliquid necessitatibus qui magnam modi voluptate voluptas eu blanditiis,Aliquid necessitatibus qui magnam modi voluptate voluptas eu blanditiis",
//       image: "1731512620-image.jpg",
//       status: 0,
//       created_at: "2024-11-13T15:43:40.000000Z",
//       updated_at: "2025-01-12T17:24:18.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       is_expire: true,
//       payment: {
//         id: 22,
//         phone_id: 43,
//         user_id: 50,
//         type: "Premium",
//         checkout_id:
//           "cs_test_a1vtUODQm1JQ3Q8h2SHbUievzYV0TTEMJAar5fNBfqw5f2dNkPRiInHjzA",
//         amount: "5",
//         payment_status: 1,
//         purchase_date: "2024-11-13 08:43:40",
//         expire_date: "2024-11-28 00:00:00",
//         is_current_plan: 1,
//         created_at: "2024-11-13T15:43:41.000000Z",
//         updated_at: "2025-03-06T17:08:14.000000Z",
//         deleted_at: null,
//         email_sent: 1,
//         email_sent_one: 1,
//       },
//     },
//   ],
//   event: [
//     {
//       id: 134,
//       name: "event name",
//       type_id: 30,
//       association_id: null,
//       image: null,
//       description: "<p>details</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: null,
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2025-03-12T18:35:47.000000Z",
//       updated_at: "2025-03-12T18:35:47.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Premium",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Premium",
//       location: [
//         {
//           id: 287,
//           event_id: 134,
//           location_id: 392,
//           date: "2025-03-14",
//           time: "00:30:00",
//           created_at: "2025-03-12T18:35:47.000000Z",
//           updated_at: "2025-03-12T18:35:47.000000Z",
//         },
//         {
//           id: 288,
//           event_id: 134,
//           location_id: 2,
//           date: "2025-03-14",
//           time: "01:00:00",
//           created_at: "2025-03-12T18:35:47.000000Z",
//           updated_at: "2025-03-12T18:35:47.000000Z",
//         },
//       ],
//       payment: {
//         id: 68,
//         user_id: 50,
//         event_id: 134,
//         type: "Premium",
//         checkout_id:
//           "cs_test_a19wJ3adYj0VJTalorwmVqKszAmWif3qSXFsn84oZUPtoQw7UdD3qb7Maz",
//         amount: "10",
//         payment_status: 1,
//         purchase_date: "2025-03-12 11:35:48",
//         expire_date: "2025-04-11 11:35:47",
//         is_current_plan: 1,
//         created_at: "2025-03-12T18:35:48.000000Z",
//         updated_at: "2025-03-12T18:36:13.000000Z",
//         deleted_at: null,
//       },
//       video: [
//         {
//           id: 206,
//           event_id: 134,
//           link: null,
//           created_at: "2025-03-12T18:35:47.000000Z",
//           updated_at: "2025-03-12T18:35:47.000000Z",
//         },
//       ],
//     },
//     {
//       id: 133,
//       name: "namee",
//       type_id: 28,
//       association_id: null,
//       image: null,
//       description: "<p>details</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: null,
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2025-03-12T18:32:53.000000Z",
//       updated_at: "2025-03-12T18:32:53.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Premium",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Premium",
//       location: [
//         {
//           id: 285,
//           event_id: 133,
//           location_id: 391,
//           date: "2025-03-13",
//           time: "22:30:00",
//           created_at: "2025-03-12T18:32:53.000000Z",
//           updated_at: "2025-03-12T18:32:53.000000Z",
//         },
//         {
//           id: 286,
//           event_id: 133,
//           location_id: 3,
//           date: "2025-03-12",
//           time: "23:00:00",
//           created_at: "2025-03-12T18:32:53.000000Z",
//           updated_at: "2025-03-12T18:32:53.000000Z",
//         },
//       ],
//       payment: {
//         id: 67,
//         user_id: 50,
//         event_id: 133,
//         type: "Premium",
//         checkout_id:
//           "cs_test_a147uxBQaWKzuI0ot2ocryuSD2YenULENlNDIgi6XiIM39go970Bu5KuHv",
//         amount: "10",
//         payment_status: 1,
//         purchase_date: "2025-03-12 11:32:53",
//         expire_date: "2025-04-11 11:32:53",
//         is_current_plan: 1,
//         created_at: "2025-03-12T18:32:53.000000Z",
//         updated_at: "2025-03-12T18:36:13.000000Z",
//         deleted_at: null,
//       },
//       video: [
//         {
//           id: 205,
//           event_id: 133,
//           link: null,
//           created_at: "2025-03-12T18:32:53.000000Z",
//           updated_at: "2025-03-12T18:32:53.000000Z",
//         },
//       ],
//     },
//     {
//       id: 132,
//       name: "namee",
//       type_id: 28,
//       association_id: null,
//       image: null,
//       description: "<p>details</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: null,
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2025-03-12T18:31:18.000000Z",
//       updated_at: "2025-03-12T18:31:18.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Premium",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Premium",
//       location: [],
//       payment: null,
//       video: [],
//     },
//     {
//       id: 131,
//       name: "namee",
//       type_id: 28,
//       association_id: null,
//       image: null,
//       description: "<p>details</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: null,
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2025-03-12T18:28:26.000000Z",
//       updated_at: "2025-03-12T18:28:26.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Premium",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Premium",
//       location: [],
//       payment: null,
//       video: [],
//     },
//     {
//       id: 130,
//       name: "namee",
//       type_id: 28,
//       association_id: null,
//       image: null,
//       description: "<p>details</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: null,
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2025-03-12T18:16:19.000000Z",
//       updated_at: "2025-03-12T18:16:19.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Standard",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Standard",
//       location: [
//         {
//           id: 283,
//           event_id: 130,
//           location_id: 390,
//           date: "2025-03-13",
//           time: "22:30:00",
//           created_at: "2025-03-12T18:16:19.000000Z",
//           updated_at: "2025-03-12T18:16:19.000000Z",
//         },
//         {
//           id: 284,
//           event_id: 130,
//           location_id: 3,
//           date: "2025-03-12",
//           time: "23:00:00",
//           created_at: "2025-03-12T18:16:19.000000Z",
//           updated_at: "2025-03-12T18:16:19.000000Z",
//         },
//       ],
//       payment: null,
//       video: [
//         {
//           id: 204,
//           event_id: 130,
//           link: null,
//           created_at: "2025-03-12T18:16:19.000000Z",
//           updated_at: "2025-03-12T18:16:19.000000Z",
//         },
//       ],
//     },
//     {
//       id: 129,
//       name: "name",
//       type_id: 27,
//       association_id: null,
//       image: null,
//       description: "<p>details</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: null,
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2025-03-12T18:11:43.000000Z",
//       updated_at: "2025-03-12T18:11:43.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Standard",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Standard",
//       location: [],
//       payment: null,
//       video: [],
//     },
//     {
//       id: 125,
//       name: "Cathleen Curtis",
//       type_id: 5,
//       association_id: null,
//       image: null,
//       description: "<p>DDD</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: null,
//       sponsor_url: null,
//       ticket_url: "https://fonts.google.com/",
//       created_at: "2025-02-28T19:36:47.000000Z",
//       updated_at: "2025-02-28T19:37:36.000000Z",
//       created_by: 50,
//       updated_by: 1,
//       status: 1,
//       admin_status: 1,
//       payment_type: "Standard",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Standard",
//       location: [
//         {
//           id: 278,
//           event_id: 125,
//           location_id: 4,
//           date: "2025-03-01",
//           time: "00:30:00",
//           created_at: "2025-02-28T19:37:36.000000Z",
//           updated_at: "2025-02-28T19:37:36.000000Z",
//         },
//       ],
//       payment: {
//         id: 63,
//         user_id: 50,
//         event_id: 125,
//         type: "Standard",
//         checkout_id: null,
//         amount: "10",
//         payment_status: 1,
//         purchase_date: null,
//         expire_date: null,
//         is_current_plan: 1,
//         created_at: "2025-02-28T19:37:37.000000Z",
//         updated_at: "2025-03-12T18:36:13.000000Z",
//         deleted_at: null,
//       },
//       video: [
//         {
//           id: 199,
//           event_id: 125,
//           link: "https://www.zomib.org.uk",
//           created_at: "2025-02-28T19:37:36.000000Z",
//           updated_at: "2025-02-28T19:37:36.000000Z",
//         },
//       ],
//     },
//     {
//       id: 124,
//       name: "event name",
//       type_id: 6,
//       association_id: null,
//       image: null,
//       description: "<p>details will be out soon</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: "1740765972-flyer.jpg",
//       sponsor_url: null,
//       ticket_url: "google.com",
//       created_at: "2025-02-28T18:06:12.000000Z",
//       updated_at: "2025-02-28T18:19:12.000000Z",
//       created_by: 50,
//       updated_by: 1,
//       status: 1,
//       admin_status: 1,
//       payment_type: "Premium",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Premium",
//       location: [
//         {
//           id: 273,
//           event_id: 124,
//           location_id: 33,
//           date: "2025-03-06",
//           time: "18:30:00",
//           created_at: "2025-02-28T18:19:12.000000Z",
//           updated_at: "2025-02-28T18:19:12.000000Z",
//         },
//       ],
//       payment: {
//         id: 62,
//         user_id: 50,
//         event_id: 124,
//         type: "Premium",
//         checkout_id: null,
//         amount: "25",
//         payment_status: 1,
//         purchase_date: null,
//         expire_date: null,
//         is_current_plan: 1,
//         created_at: "2025-02-28T18:06:45.000000Z",
//         updated_at: "2025-03-12T18:36:13.000000Z",
//         deleted_at: null,
//       },
//       video: [
//         {
//           id: 194,
//           event_id: 124,
//           link: "https://youtu.be/JcQ50-rnAh4?si=75VsnoxxP5thec15",
//           created_at: "2025-02-28T18:19:12.000000Z",
//           updated_at: "2025-02-28T18:19:12.000000Z",
//         },
//       ],
//     },
//     {
//       id: 122,
//       name: "sunt delectus",
//       type_id: 28,
//       association_id: 50,
//       image: null,
//       description: "<p>details will be out soon</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: "1740530974-flyer.jpg",
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2025-02-26T00:49:34.000000Z",
//       updated_at: "2025-03-12T18:37:18.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 1,
//       payment_type: "Premium",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Premium",
//       location: [
//         {
//           id: 289,
//           event_id: 122,
//           location_id: 371,
//           date: "2025-03-12",
//           time: "06:30:00",
//           created_at: "2025-03-12T18:37:18.000000Z",
//           updated_at: "2025-03-12T18:37:18.000000Z",
//         },
//       ],
//       payment: {
//         id: 61,
//         user_id: 50,
//         event_id: 122,
//         type: "Premium",
//         checkout_id:
//           "cs_test_a1ADNOQuhMYRT7dPjhAlJCBNQr7dzO424T5Pd8wdKOCNobelaAglH88D5c",
//         amount: "25",
//         payment_status: 1,
//         purchase_date: "2025-02-25 17:49:35",
//         expire_date: "2025-03-27 17:49:34",
//         is_current_plan: 1,
//         created_at: "2025-02-26T00:49:35.000000Z",
//         updated_at: "2025-03-12T18:36:13.000000Z",
//         deleted_at: null,
//       },
//       video: [
//         {
//           id: 207,
//           event_id: 122,
//           link: "https://youtu.be/OXK7X00x8Zg?si=So8LxEr4xYptbttk",
//           created_at: "2025-03-12T18:37:18.000000Z",
//           updated_at: "2025-03-12T18:37:18.000000Z",
//         },
//         {
//           id: 208,
//           event_id: 122,
//           link: "https://youtu.be/OXK7X00x8Zg?si=So8LxEr4xYptbttk",
//           created_at: "2025-03-12T18:37:18.000000Z",
//           updated_at: "2025-03-12T18:37:18.000000Z",
//         },
//       ],
//     },
//     {
//       id: 119,
//       name: "name",
//       type_id: 30,
//       association_id: null,
//       image: null,
//       description:
//         "<p>(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in tcascjbsdjcbjdsbcjsdbcjdsbcjbdsjcbsjdcbjsdbcjsdbhe event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)(You must enter at least one location and please fill out all details in the event location.)</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: null,
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2025-02-21T16:44:40.000000Z",
//       updated_at: "2025-02-21T16:44:40.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Standard",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Standard",
//       location: [
//         {
//           id: 255,
//           event_id: 119,
//           location_id: 372,
//           date: "2025-02-22",
//           time: "21:45:00",
//           created_at: "2025-02-21T16:44:40.000000Z",
//           updated_at: "2025-02-21T16:44:40.000000Z",
//         },
//       ],
//       payment: null,
//       video: [
//         {
//           id: 173,
//           event_id: 119,
//           link: null,
//           created_at: "2025-02-21T16:44:40.000000Z",
//           updated_at: "2025-02-21T16:44:40.000000Z",
//         },
//       ],
//     },
//     {
//       id: 102,
//       name: "Classical",
//       type_id: 28,
//       association_id: 50,
//       image: "1740430325-image.jpg",
//       description: "<p>details of the dummy data</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: "1740430325-flyer.jpg",
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2025-01-09T18:19:56.000000Z",
//       updated_at: "2025-02-26T00:47:58.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Premium",
//       deleted_at: null,
//       ip_address: "43.242.116.64",
//       type: "Premium",
//       location: [
//         {
//           id: 261,
//           event_id: 102,
//           location_id: 371,
//           date: "2025-03-06",
//           time: "23:15:00",
//           created_at: "2025-02-26T00:47:58.000000Z",
//           updated_at: "2025-02-26T00:47:58.000000Z",
//         },
//       ],
//       payment: {
//         id: 39,
//         user_id: 50,
//         event_id: 102,
//         type: "Standard",
//         checkout_id:
//           "cs_test_a1gT6tRkZMhfw3MSVgMbdIXRO4c1eDjvm4DIjttPVHllOfeU1bxlXwGRhj",
//         amount: "25",
//         payment_status: 1,
//         purchase_date: "2025-01-09 11:19:56",
//         expire_date: "2025-02-08 11:19:56",
//         is_current_plan: 1,
//         created_at: "2025-01-09T18:19:56.000000Z",
//         updated_at: "2025-03-12T18:36:13.000000Z",
//         deleted_at: null,
//       },
//       video: [
//         {
//           id: 179,
//           event_id: 102,
//           link: null,
//           created_at: "2025-02-26T00:47:58.000000Z",
//           updated_at: "2025-02-26T00:47:58.000000Z",
//         },
//       ],
//     },
//     {
//       id: 101,
//       name: "Classical",
//       type_id: 6,
//       association_id: null,
//       image: null,
//       description: "<p>hey</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: "1736446720-flyer.png",
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2025-01-09T18:18:40.000000Z",
//       updated_at: "2025-02-20T16:58:42.000000Z",
//       created_by: 50,
//       updated_by: 1,
//       status: 1,
//       admin_status: 1,
//       payment_type: "Standard",
//       deleted_at: null,
//       ip_address: "1.22.221.42",
//       type: "Standard",
//       location: [
//         {
//           id: 253,
//           event_id: 101,
//           location_id: 109,
//           date: "2025-03-09",
//           time: "23:00:00",
//           created_at: "2025-02-20T16:58:42.000000Z",
//           updated_at: "2025-02-20T16:58:42.000000Z",
//         },
//       ],
//       payment: {
//         id: 57,
//         user_id: 50,
//         event_id: 101,
//         type: "Standard",
//         checkout_id: null,
//         amount: "25",
//         payment_status: 1,
//         purchase_date: null,
//         expire_date: null,
//         is_current_plan: 1,
//         created_at: "2025-02-20T16:58:44.000000Z",
//         updated_at: "2025-03-12T18:36:13.000000Z",
//         deleted_at: null,
//       },
//       video: [
//         {
//           id: 171,
//           event_id: 101,
//           link: null,
//           created_at: "2025-02-20T16:58:42.000000Z",
//           updated_at: "2025-02-20T16:58:42.000000Z",
//         },
//       ],
//     },
//     {
//       id: 100,
//       name: "Classical",
//       type_id: 28,
//       association_id: null,
//       image: null,
//       description: "<p>Hey</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: "1736445485-flyer.png",
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2025-01-09T17:58:05.000000Z",
//       updated_at: "2025-01-09T17:58:05.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Premium",
//       deleted_at: null,
//       ip_address: "1.22.221.42",
//       type: "Premium",
//       location: [
//         {
//           id: 210,
//           event_id: 100,
//           location_id: 371,
//           date: "2025-01-09",
//           time: "03:00:00",
//           created_at: "2025-01-09T17:58:05.000000Z",
//           updated_at: "2025-01-09T17:58:05.000000Z",
//         },
//       ],
//       payment: {
//         id: 38,
//         user_id: 50,
//         event_id: 100,
//         type: "Standard",
//         checkout_id:
//           "cs_test_a1GwysmYZO3awnqgKHFWgwAB05EMzh4hTBOZT80vat7muOYQIc2iIczniF",
//         amount: "25",
//         payment_status: 1,
//         purchase_date: "2025-01-09 10:58:05",
//         expire_date: "2025-02-08 10:58:05",
//         is_current_plan: 1,
//         created_at: "2025-01-09T17:58:05.000000Z",
//         updated_at: "2025-03-12T18:36:13.000000Z",
//         deleted_at: null,
//       },
//       video: [
//         {
//           id: 128,
//           event_id: 100,
//           link: null,
//           created_at: "2025-01-09T17:58:05.000000Z",
//           updated_at: "2025-01-09T17:58:05.000000Z",
//         },
//       ],
//     },
//     {
//       id: 99,
//       name: "Classical",
//       type_id: 28,
//       association_id: null,
//       image: null,
//       description:
//         '<ol>\r\n  <li><em><strong>Hey</strong></em><a href="hey"><em><strong>hey</strong></em></a><em><strong>&nbsp;</strong></em></li>\r\n</ol>',
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: "1736445090-flyer.png",
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2025-01-09T17:51:34.000000Z",
//       updated_at: "2025-01-09T17:51:34.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Premium",
//       deleted_at: null,
//       ip_address: "1.22.221.42",
//       type: "Premium",
//       location: [
//         {
//           id: 209,
//           event_id: 99,
//           location_id: 371,
//           date: "2025-01-09",
//           time: "22:30:00",
//           created_at: "2025-01-09T17:51:34.000000Z",
//           updated_at: "2025-01-09T17:51:34.000000Z",
//         },
//       ],
//       payment: {
//         id: 37,
//         user_id: 50,
//         event_id: 99,
//         type: "Standard",
//         checkout_id:
//           "cs_test_a1zjZLv08JjLBWathV1a6V2x0ovAW7MSu3V0C3JO8tL8kzpWPJLxFsEtzP",
//         amount: "25",
//         payment_status: 1,
//         purchase_date: "2025-01-09 10:51:36",
//         expire_date: "2025-02-08 10:51:34",
//         is_current_plan: 1,
//         created_at: "2025-01-09T17:51:36.000000Z",
//         updated_at: "2025-03-12T18:36:13.000000Z",
//         deleted_at: null,
//       },
//       video: [
//         {
//           id: 127,
//           event_id: 99,
//           link: null,
//           created_at: "2025-01-09T17:51:34.000000Z",
//           updated_at: "2025-01-09T17:51:34.000000Z",
//         },
//       ],
//     },
//     {
//       id: 91,
//       name: "Lawrence Mcleod",
//       type_id: 5,
//       association_id: 50,
//       image: "1731165989-image.jpg",
//       description: "<p>dsadasdasdasd lorem ipsum&nbsp;</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: "1731165989-flyer.jpg",
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2024-11-09T15:26:29.000000Z",
//       updated_at: "2024-12-04T15:58:52.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 0,
//       admin_status: 1,
//       payment_type: "Premium",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Premium",
//       location: [
//         {
//           id: 202,
//           event_id: 91,
//           location_id: 6,
//           date: "2024-11-14",
//           time: "20:00:00",
//           created_at: "2024-12-04T15:58:12.000000Z",
//           updated_at: "2024-12-04T15:58:12.000000Z",
//         },
//         {
//           id: 203,
//           event_id: 91,
//           location_id: 2,
//           date: "2024-12-28",
//           time: "21:00:00",
//           created_at: "2024-12-04T15:58:12.000000Z",
//           updated_at: "2024-12-04T15:58:12.000000Z",
//         },
//         {
//           id: 204,
//           event_id: 91,
//           location_id: 3,
//           date: "2024-12-28",
//           time: "21:30:00",
//           created_at: "2024-12-04T15:58:12.000000Z",
//           updated_at: "2024-12-04T15:58:12.000000Z",
//         },
//       ],
//       payment: {
//         id: 30,
//         user_id: 50,
//         event_id: 91,
//         type: "Standard",
//         checkout_id:
//           "cs_test_a1EtVPxrHvfa9zJkPSrHYWnURZiV6wcOkxzLFrDudcyvVIqhQ8sJmJCk24",
//         amount: "25",
//         payment_status: 1,
//         purchase_date: "2024-11-09 08:26:29",
//         expire_date: "2024-12-09 08:26:29",
//         is_current_plan: 1,
//         created_at: "2024-11-09T15:26:29.000000Z",
//         updated_at: "2025-03-12T18:36:13.000000Z",
//         deleted_at: null,
//       },
//       video: [
//         {
//           id: 121,
//           event_id: 91,
//           link: "https://www.vawowynarozum.org",
//           created_at: "2024-12-04T15:58:12.000000Z",
//           updated_at: "2024-12-04T15:58:12.000000Z",
//         },
//       ],
//     },
//     {
//       id: 90,
//       name: "Pandora Humphrey",
//       type_id: 5,
//       association_id: null,
//       image: null,
//       description: "<p>sadasdasdasd</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: "1731165922-flyer.png",
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2024-11-09T15:25:25.000000Z",
//       updated_at: "2025-02-20T17:05:01.000000Z",
//       created_by: 50,
//       updated_by: 1,
//       status: 1,
//       admin_status: 1,
//       payment_type: "Standard",
//       deleted_at: null,
//       ip_address: "42.106.9.79",
//       type: "Standard",
//       location: [
//         {
//           id: 254,
//           event_id: 90,
//           location_id: 17,
//           date: "2025-04-18",
//           time: "21:15:00",
//           created_at: "2025-02-20T17:05:01.000000Z",
//           updated_at: "2025-02-20T17:05:01.000000Z",
//         },
//       ],
//       payment: {
//         id: 58,
//         user_id: 50,
//         event_id: 90,
//         type: "Standard",
//         checkout_id: null,
//         amount: "25",
//         payment_status: 1,
//         purchase_date: null,
//         expire_date: null,
//         is_current_plan: 1,
//         created_at: "2025-02-20T17:05:03.000000Z",
//         updated_at: "2025-03-12T18:36:13.000000Z",
//         deleted_at: null,
//       },
//       video: [
//         {
//           id: 172,
//           event_id: 90,
//           link: "https://www.jagiwyzutymowa.us",
//           created_at: "2025-02-20T17:05:01.000000Z",
//           updated_at: "2025-02-20T17:05:01.000000Z",
//         },
//       ],
//     },
//     {
//       id: 73,
//       name: "test event",
//       type_id: 27,
//       association_id: null,
//       image: null,
//       description: "<p>test location&nbsp;</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: "1728940467-flyer.jpg",
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2024-10-15T04:14:27.000000Z",
//       updated_at: "2024-10-15T04:14:27.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Premium",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Premium",
//       location: [
//         {
//           id: 108,
//           event_id: 73,
//           location_id: 370,
//           date: "2024-10-17",
//           time: "02:30:00",
//           created_at: "2024-10-15T04:14:27.000000Z",
//           updated_at: "2024-10-15T04:14:27.000000Z",
//         },
//       ],
//       payment: {
//         id: 14,
//         user_id: 50,
//         event_id: 73,
//         type: "Standard",
//         checkout_id:
//           "cs_test_a1IrkKgbBVzyXGcv3h3X1y0GZnliVbQiMNBzYk8X1O39IP4pncuw24Md2B",
//         amount: "25",
//         payment_status: 1,
//         purchase_date: "2024-10-14 21:14:27",
//         expire_date: null,
//         is_current_plan: 1,
//         created_at: "2024-10-15T04:14:27.000000Z",
//         updated_at: "2025-03-12T18:36:13.000000Z",
//         deleted_at: null,
//       },
//       video: [
//         {
//           id: 49,
//           event_id: 73,
//           link: "https://www.google.org.au",
//           created_at: "2024-10-15T04:14:27.000000Z",
//           updated_at: "2024-10-15T04:14:27.000000Z",
//         },
//       ],
//     },
//     {
//       id: 72,
//       name: "event name",
//       type_id: 6,
//       association_id: null,
//       image: null,
//       description: "<p>details</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: null,
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2024-10-10T20:18:09.000000Z",
//       updated_at: "2024-10-10T20:18:09.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Standard",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Standard",
//       location: [
//         {
//           id: 107,
//           event_id: 72,
//           location_id: 38,
//           date: "2024-10-23",
//           time: "18:45:00",
//           created_at: "2024-10-10T20:18:09.000000Z",
//           updated_at: "2024-10-10T20:18:09.000000Z",
//         },
//       ],
//       payment: null,
//       video: [
//         {
//           id: 48,
//           event_id: 72,
//           link: null,
//           created_at: "2024-10-10T20:18:09.000000Z",
//           updated_at: "2024-10-10T20:18:09.000000Z",
//         },
//       ],
//     },
//     {
//       id: 71,
//       name: "event name",
//       type_id: 6,
//       association_id: null,
//       image: null,
//       description: "<p>details</p>",
//       sponsor_logo: null,
//       sponsor_email_logo: null,
//       flyer: null,
//       sponsor_url: null,
//       ticket_url: null,
//       created_at: "2024-10-10T20:14:34.000000Z",
//       updated_at: "2024-10-10T20:14:34.000000Z",
//       created_by: 50,
//       updated_by: 50,
//       status: 1,
//       admin_status: 0,
//       payment_type: "Standard",
//       deleted_at: null,
//       ip_address: "103.112.218.174",
//       type: "Standard",
//       location: [
//         {
//           id: 106,
//           event_id: 71,
//           location_id: 38,
//           date: "2024-10-23",
//           time: "18:45:00",
//           created_at: "2024-10-10T20:14:34.000000Z",
//           updated_at: "2024-10-10T20:14:34.000000Z",
//         },
//       ],
//       payment: null,
//       video: [
//         {
//           id: 47,
//           event_id: 71,
//           link: null,
//           created_at: "2024-10-10T20:14:34.000000Z",
//           updated_at: "2024-10-10T20:14:34.000000Z",
//         },
//       ],
//     },
//   ],
// };